import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { ThemeProvider, CssBaseline } from "@mui/material";
import theme from "./theme";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import { initKeycloak } from "./auth/initKeycloak";
import { UserProvider } from "./context/UserContext";
import SessionIdleGuard from "./components/SessionIdleGuard";

// SurveyJS CSS imports (optional - component may not need them)
try {
  require("survey-core/defaultV2.min.css");
  require("survey-creator-core/survey-creator-core.min.css");
} catch (e) {
  console.warn("SurveyJS CSS files not found, component styling will be minimal");
}

/* ------------------ Async Bootstrap ------------------ */

const root = ReactDOM.createRoot(document.getElementById("root"));

async function bootstrap() {
  await initKeycloak(); // Initialize Keycloak before rendering app

  root.render(
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LocalizationProvider
        dateAdapter={AdapterDayjs}
        dateFormats={{ keyboardDate: "MM/DD/YYYY" }}
      >
        <UserProvider>
          <SessionIdleGuard>
            <App />
          </SessionIdleGuard>
        </UserProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

bootstrap();

reportWebVitals();
